import { JsonPathMappingItem } from "./JsonPathMappingItem";
import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";

export class JsonPathMapping {
    items: OrdinaryObject<JsonPathMappingItem>;
}
